
import React from "react";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";

interface DocumentNumberFieldProps {
  form: UseFormReturn<any>;
  sectionIndex: number;
}

const DocumentNumberField = ({ form, sectionIndex }: DocumentNumberFieldProps) => {
  return (
    <FormField
      control={form.control}
      name={`sections.${sectionIndex}.document_number`}
      render={({ field }) => (
        <FormItem>
          <FormLabel>Document Number</FormLabel>
          <FormControl>
            <Input placeholder="Enter document number" {...field} />
          </FormControl>
          <FormDescription>
            The identification number printed on your document (e.g.,
            passport number)
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default DocumentNumberField;
